import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';

const OriginalResult = ({ query, phraseStart }) => (
    <React.Fragment>
        <I18n k="search_perseus.search_results_counter.showing_results" params={{ phraseStart }}/>&nbsp;
        {'"'}<b>{query}</b>{'"'}
    </React.Fragment>
);

export default OriginalResult;
